import { Line } from '@react-three/drei';

function CubicSpaceAvailableLabel({
  productLength,
  productWidth,
  productHeight,
}) {
  const renderLabel = (position, color) => (
    <Line
      points={[
        [-position[0], -position[1], -position[2]],
        [position[0], position[1], position[2]],
      ].filter(Boolean)}
      color={color}
      lineWidth={3}
    />
  );

  return (
    <>
      {renderLabel([productWidth / 2, 0, 0], 'green')}
      {renderLabel([0, productHeight / 2, 0], 'red')}
      {renderLabel([0, 0, -productLength / 2], 'blue')}
    </>
  );
}

export default CubicSpaceAvailableLabel;
